import React from 'react';
import ProfileAvatar from './user_profile_avatar';
import OPPureComponent from '../op_pure_component';

export default class ParticipantAvatar extends OPPureComponent {
  render() {
    if (!this.props.participant) return null;

    const { profile } = this.props.participant;

    return <ProfileAvatar profile={profile} {...this.props} />;
  }
}
